import { browserInfo } from "@/utils";
import { serverTimestamp } from "@/utils/firebase-helper";
import "firebase/analytics";
import firebase from "firebase/app";
import "firebase/auth"; // for authentication
import "firebase/database"; // for realtime database
import "firebase/firestore"; // for cloud firestore
import "firebase/functions";
import "firebase/performance";
import "firebase/storage"; // for storage
import { uuidv4 } from "vue-chess-shared/utils";
import { isNumeric } from "vue-chess-shared/utils/number-helper";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const database = firebaseApp.database();
const firestore = firebaseApp.firestore();
const storage = firebaseApp.storage();
const functions = firebaseApp.functions();
const auth = firebaseApp.auth();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
// const performance = firebaseApp.performance();
const analytics = firebaseApp.analytics();

if (
  process.env.NODE_ENV === "development" &&
  !!process.env.VUE_APP_USE_EMULATOR
) {
  functions.useEmulator("localhost", 5001);
  firestore.useEmulator("localhost", 9001);
  database.useEmulator("localhost", 9002);
  storage.useEmulator("localhost", 9199);
  console.log("Used firebase emulators");
}

export {
  analytics,
  auth,
  database,
  facebookAuthProvider,
  firestore,
  functions,
  googleAuthProvider,
  storage,
};

export const initFirestoreTimeOffset = () => {
  sessionStorage.setItem("firestoreTimeOffset", 0); // Set to 0 first then try to query firestore

  let userId = sessionStorage.getItem("userId");

  if (!userId) userId = uuidv4();

  console.log({ userId });

  const ref = firestore.collection("users").doc(userId);
  ref
    .set({
      localTimestamp: new Date(),
      serverTimestamp: serverTimestamp(),
    })
    .then(() => {
      ref.get().then((doc) => {
        const data = doc.data();
        const firestoreTimeOffset = data.serverTimestamp - data.localTimestamp;

        console.log("client firestore timeoffset", firestoreTimeOffset);
        if (isNumeric(firestoreTimeOffset)) {
          sessionStorage.setItem("firestoreTimeOffset", firestoreTimeOffset);
        }
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

export const initRtdbPresence = () => {
  const userId = sessionStorage.getItem("userId");
  if (!userId) return;

  const rtdbTimeOffset = parseInt(sessionStorage.getItem("rtdbTimeOffset"));
  console.log({ rtdbTimeOffset });

  if (!rtdbTimeOffset) {
    sessionStorage.setItem("rtdbTimeOffset", 0); // Set to 0 first then try to query firebase
    const offsetRef = firebase.database().ref(".info/serverTimeOffset");
    offsetRef.on("value", function (snap) {
      const offset = snap.val();
      console.log("new rtdbTimeOffset", offset);
      if (isNumeric(offset)) sessionStorage.setItem("rtdbTimeOffset", offset);
    });
  }

  // since I can connect from multiple devices or browser tabs, we store each connection instance separately
  // any time that connectionsRef's value is null (i.e. has no children) I am offline
  const myConnectionsRef = firebase
    .database()
    .ref(`users/${userId}/connections`);

  // stores the timestamp of my last disconnect (the last time I was seen online)
  const lastOnlineRef = firebase.database().ref(`users/${userId}/lastOnline`);

  const connectedRef = firebase.database().ref(".info/connected");
  connectedRef.on("value", function (snap) {
    if (snap.val() === true) {
      // We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)
      const con = myConnectionsRef.push();

      // When I disconnect, remove this device
      con.onDisconnect().remove();

      // Add this device to my connections list
      // this value could contain info about the device or a timestamp too
      con.set({
        ...browserInfo(),
        createdAt: firebase.database.ServerValue.TIMESTAMP,
      });

      // When I disconnect, update the last time I was seen online
      lastOnlineRef.onDisconnect().set(firebase.database.ServerValue.TIMESTAMP);
    }
  });
};
